export default __webpack_public_path__ + "static/media/payment-and-subscription.ee82566b.svg";